export default __webpack_public_path__ + "static/media/Hair benifits kit 1.a881eada.jpg";